module.exports = __webpack_public_path__ + "7e3550d74cb0379fee19ce084858abf3.svg";